// Pure filtering logic shared by the provider-search-filters Stimulus
// controller and its node:test suite.

export function providerMatchesFilters(provider, { activeOnly, hiddenAppearances = [] }) {
  if (activeOnly && provider.likelyActive === "false") return false

  const appearance = provider.searchAppearance?.toLowerCase()
  if (appearance && hiddenAppearances.includes(appearance)) return false

  return true
}

export function visibleProviderIndexes(providers, filters) {
  return providers
    .filter((provider) => providerMatchesFilters(provider, filters))
    .map((provider) => provider.providerResultIndex)
    .filter((index) => index !== undefined)
}
